import React from "react";
import axios from "axios";
import { Row, Col, Input, Space, Form, Button, message, Select } from "antd";
import { RightCircleOutlined } from '@ant-design/icons';

const options = [];

for (let i = 10; i < 36; i++) {
    options.push({
        value: i.toString(36) + i,
        label: i.toString(36) + i,
    });
}
const handleChange = (value) => {
    console.log(`Selected: ${value}`);
};

const text = '這本書讓我深受啟發。它教會了我許多寶貴的人生智慧和價值觀。書中的主角面臨著困難和挑戰，但他從中學到了堅持和努力的重要性。我從他身上學到了永不放棄的精神，並且明白成功需要付出艱辛的努力和付諸實踐的行動。這本書還深刻地探討了人與人之間的關係和情感。主角的成長和與他人的互動讓我思考自己與他人之間的互動方式。書中描述的友誼和家庭關係，提醒了我重要的價值，例如理解、支持和關懷。我希望能夠將這些價值帶入我的日常生活中，並與身邊的人建立更深層次的連結。此外，這本書也探討了重要的道德問題和倫理觀。主角面臨許多道德抉擇，並在這些抉擇中展現出他的品格和道德勇氣。這讓我思考自己的價值觀和道德底線，並鞏固了我對正義和善良的信念。總的來說，這本書對我產生了深遠的影響。它不僅提供了娛樂，還啟發了我對人生和價值觀的思考。這本書教會了我重要的生活原則，並激勵我在困難中堅持不懈。我強烈推薦這本書，相信它能夠為其他讀者帶來同樣的啟發和啟迪。'

const App = () => {

    const [form] = Form.useForm();
    const handleOnFinish = (values) => {
        console.log(values)
        axios
            .get('/xxx/xxx')
            .then(() => {
                message.success('已完成推薦，請期待新進藏書')
            })
            .catch(() => {
                message.error('推薦失敗，請通知館員')
            })
    }

    return (<>
        <Row gutter={[0, 12]}>
            <Col span={24} />
            <Col>
                <div style={{ backgroundColor: '#FFDAB9', width: 'fit-content', padding: '10px 15px', fontSize: '1.3em', borderRadius: '10px', boxShadow: '#e86813 1px 2px 0px' }}>
                    閱讀回饋
                </div>
            </Col>
            <Col lg={{ span: 24 }} xs={{ span: 0 }} span={24} style={{ borderRadius: '5px', display: 'flex', border: 'lightgrey solid 1px', padding: '20px' }}>
                <Row gutter={[0, 20]} >
                    <Col span={24}>
                        <Row gutter={[20, 20]}>
                            <Col span={24} />

                            <Col>
                                <div style={{ backgroundColor: '#FFDAB9', width: 'fit-content', padding: '10px 15px', fontSize: '1.3em', borderRadius: '10px', boxShadow: '#e86813 1px 2px 0px' }}>
                                    自動帶入區
                                </div>
                            </Col>
                            <Col span={24}>
                                <div style={{ borderRadius: '5px', display: 'flex', justifyContent: 'space-around', border: 'lightgrey solid 1px' }}>
                                    <div style={{ width: '-webkit-fill-available', padding: '20px' }}>
                                        <Form
                                            form={form}
                                            name="basic"
                                            labelCol={{
                                                span: 3,
                                            }}
                                            wrapperCol={{
                                                span: 8,
                                            }}
                                            style={{
                                                minWidth: 600,
                                            }}
                                            initialValues={{
                                                remember: true,
                                            }}
                                            autoComplete="off"
                                        >
                                            <text style={{ fontSize: '1.5em', color: 'red' }}>*必填</text>
                                            <Form.Item
                                                label="書名"
                                                name="name"
                                                rules={[
                                                    {
                                                        required: true,
                                                    },
                                                ]}
                                            >
                                                <Input style={{ width: 330 }} defaultValue={'南方，寂寞鐵道：我們在時光列車上相遇'} />
                                            </Form.Item>

                                            <Form.Item
                                                label="ISBN"
                                                name="ISBN"
                                                rules={[
                                                    {
                                                        required: true,
                                                    },
                                                ]}
                                            >
                                                <Input defaultValue={'98763452545'} />
                                            </Form.Item>

                                            <Form.Item
                                                label="作者"
                                                name="Author"
                                                rules={[
                                                    {
                                                        required: true,
                                                    },
                                                ]}
                                            >
                                                <Input defaultValue={'蕭菊貞'} />
                                            </Form.Item>
                                        </Form>
                                    </div>
                                    <div style={{ width: '-webkit-fill-available', padding: '20px' }}>
                                        <Form
                                            form={form}
                                            name="basic"
                                            labelCol={{
                                                span: 4,
                                            }}
                                            wrapperCol={{
                                                span: 8,
                                            }}
                                            style={{
                                                maxWidth: 600,
                                            }}
                                            initialValues={{
                                                remember: true,
                                            }}
                                            autoComplete="off"
                                            onFinish={handleOnFinish}
                                        >
                                            <div><text style={{ fontSize: '1.5em', color: 'darkred' }}>選填</text><text style={{ fontSize: '1em', color: 'red' }}>（填寫可以加迷購書速度哦！）</text></div>
                                            <Form.Item
                                                label="參考網址"
                                                name="Link"
                                            >
                                                <Input defaultValue={'www.BookStore.com'} />
                                            </Form.Item>

                                            <Form.Item
                                                label="出版社"
                                                name="Publisher"
                                            >
                                                <Input defaultValue={'大塊文化'} />
                                            </Form.Item>
                                            <Form.Item
                                                label="定價"
                                                name="Price"
                                            >
                                                <Input defaultValue={'473'} />
                                            </Form.Item>
                                        </Form>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                    <Col span={24}>
                        <Row gutter={[20, 20]}>
                            <Col>
                                <div style={{ backgroundColor: '#FFDAB9', width: 'fit-content', padding: '10px 15px', fontSize: '1.3em', borderRadius: '10px', boxShadow: '#e86813 1px 2px 0px' }}>
                                    心得迴響
                                </div>
                            </Col>
                            <Col span={24}>
                                <Input.TextArea autoSize={true} defaultValue={text} />
                            </Col>
                        </Row>
                    </Col>
                    <Col span={24}>
                        <Row gutter={[20, 20]}>
                            <Col>
                                <div style={{ backgroundColor: '#FFDAB9', width: 'fit-content', padding: '10px 15px', fontSize: '1.3em', borderRadius: '10px', boxShadow: '#e86813 1px 2px 0px' }}>
                                    關鍵字推薦
                                </div>
                            </Col>
                            <Col span={24}>
                                <Select
                                    mode="tags"
                                    placeholder="Please select"
                                    defaultValue={['輕小說']}
                                    onChange={handleChange}
                                    style={{
                                        width: '30%',
                                    }}
                                    options={options}
                                />
                            </Col>
                        </Row>
                    </Col>
                    <Col span={24}>
                        <Row gutter={[20, 20]} justify={"end"}>
                            <Col>
                                <Button
                                    type="primary"
                                    icon={<RightCircleOutlined />}
                                // loading={loadings[1]}
                                // onClick={() => enterLoading(1)}
                                >
                                    送出推薦!
                                </Button>
                            </Col>
                        </Row>
                    </Col>
                    <Col span={24} />
                </Row>
            </Col>
        </Row>
    </>)
}

export default App